import { render, staticRenderFns } from "./fl44-contract-supplementary-agreement-regular-create.vue?vue&type=template&id=5b1cf901&"
import script from "./fl44-contract-supplementary-agreement-regular-create.vue?vue&type=script&lang=js&"
export * from "./fl44-contract-supplementary-agreement-regular-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1cf901')) {
      api.createRecord('5b1cf901', component.options)
    } else {
      api.reload('5b1cf901', component.options)
    }
    module.hot.accept("./fl44-contract-supplementary-agreement-regular-create.vue?vue&type=template&id=5b1cf901&", function () {
      api.rerender('5b1cf901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/fl44-contract-supplementary-agreement-regular-create.vue"
export default component.exports